<template>
  <LayoutContent>
    <AcknowledgementCard :title="`${$t('label.pointsTransferred')}!`">
      <template #acknowledgement-body>
        <v-container class="px-sm-16">
          <v-row>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.transferTo') }}
              </p>
              <p class="font-weight-medium">{{ pointTransferInfo.to_member }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.transferAmount') }}
              </p>
              <p class="font-weight-medium">{{ pointTransferInfo.transferred_points }} {{ $t('label.points') }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.dateAndTime') }}
              </p>
              <p class="font-weight-medium">
                <span class="mr-4">{{ pointTransferInfo.transfer_date | shortDate }}</span>
              </p>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </AcknowledgementCard>
  </LayoutContent>
</template>

<script>
import { mapState } from 'vuex'

import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AcknowledgementCard from '@/components/AcknowledgementCard.vue'

export default {
  name: 'MakeAppointmentComplete',
  components: {
    LayoutContent,
    AcknowledgementCard
  },

  computed: {
    ...mapState('auth', ['pointTransferInfo'])
  },

  created() {
    console.log('HERE', this.pointTransferInfo)
    // if (!this.bookingInfo.booking_number) {
    //   this.$router.push('/')
    // }
  }
}
</script>
